import { HEDERA_MAINNET, HEDERA_TESTNET } from '@/config/constants'
import type { ChainInfo, NativeCurrency, TokenInfo } from '@safe-global/safe-gateway-typescript-sdk'

const CHAINS = [HEDERA_TESTNET, HEDERA_MAINNET]

export const nativeDecimals = (item?: ChainInfo | TokenInfo) => {
  if (!item) return 18

  if ('chainId' in item) {
    if (CHAINS.includes(item.chainId)) return 18

    return item.nativeCurrency.decimals
  }

  return item.type === 'NATIVE_TOKEN' ? 18 : item.decimals
}

export const getNativeCurrency = (nativeCurrency: NativeCurrency) => {
  return { ...nativeCurrency, decimals: 18 }
}
